import React, { useMemo } from "react";
import { PAGINATION } from "@/lib/constants";
import PaginationMUI from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";

const Pagination = (props: any) => {
  const {
    totalCount = 0,
    pageSelected,
    setPageSelected,
    rowsPerPageValue = PAGINATION.DEFAULT_ROWS_PER_PAGE,
  } = props;
  
  const noOfPages = useMemo(
    () => Math.ceil(totalCount / rowsPerPageValue),
    [rowsPerPageValue, totalCount]
  );

  const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPageSelected(value);
    if (props?.setPageSelected) {
      props.setPageSelected(value);
    }
  };

  if (noOfPages <= 1) return null;

  return (
    <div style={{ display: "flex", justifyContent: "flex-end", padding: "16px" }}>
      <Stack spacing={2}>
        <PaginationMUI 
          count={noOfPages} 
          page={pageSelected} 
          onChange={handlePageChange} 
          shape="circular"
          sx={{
            "& .MuiPaginationItem-root": {
              color: "var(--text)",
            },
            "& .Mui-selected": {
              backgroundColor: "var(--accent) !important",
              color: "var(--text-on-accent, #04140f) !important",
            }
          }}
        />
      </Stack>
    </div>
  );
};

export default Pagination;
